module.exports = __webpack_public_path__ + "img/1.fe9b664f.png";